export const TIMING = {
  globeFadeIn: 0.8,
  beforeDot: 0.15,
  dotPop: 0.42,
  beforeTimezone: 0.12,
  timezoneFade: 0.6,
  beforeFlatten: 0.35,
  flatten: 1.3,
};

export const GLOBE_TILT = 0.28;
export const INTRO_SCALE = 0.78;
export const INTRO_ZOOM_OUT = 0.9;
